import { IValidator, IValidations, IClientCalendarSession } from '@/interfaces';

export class CalendarSessionValidator implements IValidator<IClientCalendarSession> {
  public isValid(item: IClientCalendarSession) {
    const errors: IValidations<IClientCalendarSession> = {};
    if (item.name.length === 0) errors.name = ['Session Name is Required'];
    if (item.date === null) errors.date = ['Session Dates are required'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}